import React, { useContext } from 'react';
import { MessageSquare, Users } from 'lucide-react';
import { CardMenu } from '../../../ui';
import { TemporaryChatContext } from '../../../../Context/temporaryChatContext';
import { AuthContext } from '../../../../Context/authContext';
import { useContextHook } from 'use-context-hook';
import { useNavigate } from 'react-router-dom';
import sessionsService from '../../../../services/sessionsServices';
import Toast from '../../../Toast';

const ACCENTS = ['#3B82F6', '#EC4899', '#10B981', '#F59E0B', '#8B5CF6', '#721b1f'];

function getImageSrc(icon) {
  if (!icon || typeof icon !== 'string') return null;
  if (icon.startsWith('http://') || icon.startsWith('https://')) {
    return icon.split('?')[0].toLowerCase().endsWith('.svg') ? null : icon;
  }
  if (icon.startsWith('data:image')) return icon;
  return null;
}

const DiscoverTeamCard = ({ teamCardsData, filterName }) => {
  const { setChatmessages, updateAgent, setSessionAgent } = useContext(TemporaryChatContext);
  const { user } = useContextHook(AuthContext, v => ({
    user: v.user,
  }));
  const navigate = useNavigate();

  const chatWithTeam = async teamObj => {
    try {
      updateAgent(teamObj);
      setSessionAgent(teamObj);
      setChatmessages([]);
      const sessionRes = await sessionsService.createSession({
        user_id: user?.data?.ID,
        platform_id: 'agentcy',
        agent_id: teamObj?.value,
        project_id: 'test',
        mode: 'team',
      });
      navigate(`/chat/${sessionRes?.session_id}`);
    } catch (error) {
      Toast({ type: 'error', message: error?.detail || error?.message || 'Could not start chat' });
    }
  };

  const filtered = (teamCardsData || []).filter(card => {
    if (!filterName?.trim()) return true;
    return card.team_name?.toLowerCase().includes(filterName.trim().toLowerCase());
  });

  if (filtered.length === 0) {
    return <div className="py-16 text-center text-mute text-sm">No teams match your search.</div>;
  }

  return (
    <>
      {filtered.map((card, index) => {
        const accent = ACCENTS[index % ACCENTS.length];
        const iconSrc = getImageSrc(card?.icon);
        const teamPayload = {
          label: card?.team_name,
          value: card?.team_id,
          icon: card?.icon,
          mode: 'team',
        };

        return (
          <button
            key={card.id || card.team_id}
            type="button"
            onClick={() => chatWithTeam(teamPayload)}
            className="w-full text-left p-4 rounded-xl bg-white border border-shell-border hover:border-ink/20 hover:bg-paper transition-all duration-200">
            <div className="flex items-start justify-between gap-3 mb-3">
              <div
                className="w-11 h-11 rounded-lg flex items-center justify-center overflow-hidden flex-shrink-0"
                style={{ backgroundColor: iconSrc ? 'transparent' : `${accent}1A` }}>
                {iconSrc ? (
                  <img src={iconSrc} alt={card.team_name} className="w-full h-full object-cover" />
                ) : (
                  <Users className="w-5 h-5" style={{ color: accent }} />
                )}
              </div>
              <div className="flex items-center gap-2 flex-shrink-0" onClick={e => e.stopPropagation()}>
                <span className="text-[11px] font-medium px-2.5 py-0.5 rounded-full bg-[#F5E6B8] text-ink">
                  Official
                </span>
                <CardMenu
                  items={[
                    {
                      label: 'Chat',
                      icon: MessageSquare,
                      onClick: () => chatWithTeam(teamPayload),
                    },
                  ]}
                />
              </div>
            </div>
            <h3 className="text-base font-semibold text-ink mb-1 truncate capitalize">{card.team_name}</h3>
            <p className="text-sm text-mute leading-relaxed line-clamp-2">
              {card.description || 'No description.'}
            </p>
          </button>
        );
      })}
    </>
  );
};

export default DiscoverTeamCard;
